import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const Ruler = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M29.121 20.879L11.121 2.879C10.554 2.312 9.801 2 9 2C8.199 2 7.445 2.312 6.879 2.879L2.879 6.879C2.312 7.445 2 8.199 2 9C2 9.801 2.312 10.555 2.879 11.121L20.879 29.121C21.446 29.688 22.199 30 23 30C23.801 30 24.555 29.688 25.121 29.121L29.121 25.121C29.688 24.554 30 23.801 30 23C30 22.199 29.688 21.445 29.121 20.879V20.879ZM27.707 23.707L23.707 27.707C23.518 27.896 23.267 28 23 28C22.733 28 22.482 27.896 22.293 27.707L4.293 9.707C4.104 9.518 4 9.267 4 9C4 8.733 4.104 8.482 4.293 8.293L8.293 4.293C8.482 4.104 8.733 4 9 4C9.267 4 9.518 4.104 9.707 4.293L12 6.586L10.293 8.293C10.112 8.474 10 8.724 10 9C10 9.552 10.448 10 11 10C11.276 10 11.526 9.888 11.707 9.707L13.414 8L16 10.586L14.293 12.293C14.112 12.474 14 12.724 14 13C14 13.552 14.448 14 15 14C15.276 14 15.526 13.888 15.707 13.707L17.414 12L20 14.586L18.293 16.293C18.112 16.474 18 16.724 18 17C18 17.552 18.448 18 19 18C19.276 18 19.526 17.888 19.707 17.707L21.414 16L24 18.586L22.293 20.293C22.112 20.474 22 20.724 22 21C22 21.552 22.448 22 23 22C23.276 22 23.526 21.888 23.707 21.707L25.414 20L27.707 22.293C27.896 22.482 28 22.733 28 23C28 23.267 27.896 23.518 27.707 23.707V23.707Z" />
	</svg>
);

export default Ruler;
